import React from 'react';
import { withLDProvider } from 'launchdarkly-react-client-sdk';
import FontAwesomeCollection from '@bit/fabfitfun.shared.global.font-awesome-collection';

import AppRoutes from './AppRoutes';
import './App.css';

function App() {
  return (
    <>
      <FontAwesomeCollection />
      <AppRoutes />
    </>
  );
}

export default withLDProvider({
  clientSideID: process.env.REACT_APP_LD_CLIENT_ID,
  options: { bootstrap: 'localStorage' },
  user: {
    key: 'anonymous',
  },
})(App);
